<template>
  <div class="profile-page">
    <div class="profile-page__top mb-5">
      <div class="d-flex h4 primary--text">
        {{ $t('views.supplier_item.supplier') }}
        <span
          v-if="supplier"
          class="profile-page__supplier-name"
        >
          {{ supplier.name }} / {{ supplier.asdb }}
        </span>
        <v-btn
          class="ml-auto"
          color="primary"
          outlined
          @click="$router.go(-1)"
        >
          {{ $t('common.goBack') }}
        </v-btn>
      </div>
    </div>
    <v-card
      v-if="supplier"
      class="profile-page__main mb-5"
    >
      <v-form
        @submit.prevent="save"
      >
        <div class="profile-page__main__item">
          <div class="profile-page__main__item__container">
            <v-row>
              <v-col
                cols="12"
                lg="4"
                class="profile-page__main__item__content"
              >
                <div class="profile-page__main__item__content__item">
                  <span class="profile-page__main__item__content__item__title">
                    {{ $t('views.supplier_item.shipping_address') }}
                  </span>
                  <div class="input-block input-block_white mt-1">
                    <v-text-field
                      v-if="full"
                      v-model="supplier.shippingAddress"
                      dense
                      solo
                    />
                    <span
                      v-else
                      class="profile-page__main__item__content__item__text"
                    >
                      {{ supplier.shippingAddress || $t('common.no_data') }}
                    </span>
                  </div>
                </div>
                <div class="profile-page__main__item__content__item">
                  <span class="profile-page__main__item__content__item__title">
                    {{ $t('views.supplier_item.physical_address') }}
                  </span>
                  <div class="input-block input-block_white mt-1">
                    <v-text-field
                      v-if="full"
                      v-model="supplier.physicalAddress"
                      dense
                      solo
                    />
                    <span
                      v-else
                      class="profile-page__main__item__content__item__text"
                    >
                      {{ supplier.physicalAddress || $t('common.no_data') }}
                    </span>
                  </div>
                </div>
                <div class="profile-page__main__item__content__item">
                  <span class="profile-page__main__item__content__item__title">
                    {{ $t('views.supplier_item.billing_address') }}
                  </span>
                  <div class="input-block input-block_white mt-1">
                    <v-text-field
                      v-if="full"
                      v-model="supplier.legalAddress"
                      dense
                      solo
                    />
                    <span
                      v-else
                      class="profile-page__main__item__content__item__text"
                    >
                      {{ supplier.legalAddress || $t('common.no_data') }}
                    </span>
                  </div>
                </div>
                <v-btn
                  v-if="full"
                  color="primary"
                  outlined
                  type="submit"
                >
                  {{ $t('common.save') }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                lg="4"
                class="profile-page__main__item__content"
              >
                <div class="profile-page__main__item__content__item">
                  <span class="profile-page__main__item__content__item__title">
                    {{ $t('views.supplier_item.country') }}
                  </span>
                  <div class="input-block input-block_white mt-1">
                    <v-text-field
                      v-if="full"
                      v-model="supplier.physicalCountry"
                      :disabled="true"
                      dense
                      solo
                    />
                    <span
                      v-else
                      class="profile-page__main__item__content__item__text"
                    >
                      {{ supplier.physicalCountry || $t('common.no_data') }}
                    </span>
                  </div>
                </div>

                <div class="profile-page__main__item__content__item">
                  <span class="profile-page__main__item__content__item__title">
                    {{ $t('views.supplier_item.shipping_time_zone') }}
                  </span>
                  <div class="input-block input-block_white mt-1">
                    <multiselect
                      v-if="full"
                      v-model="supplier.timezone"
                      :options="timezones"
                      placeholder=""
                      selected-label=""
                      select-label=""
                      deselect-label=""
                    />
                    <span
                      v-else
                      class="profile-page__main__item__content__item__text"
                    >
                      {{ supplier.timezone || $t('common.no_data') }}
                    </span>
                  </div>
                </div>

                <div class="profile-page__main__item__content__item">
                  <span class="profile-page__main__item__content__item__title">
                    {{ $t('views.supplier_item.language') }}
                  </span>
                  <div class="input-block input-block_white mt-1">
                    <v-select
                      v-if="full"
                      v-model="supplier.language"
                      :items="locales"
                      hide-details
                      solo
                    />
                    <span
                      v-else
                      class="profile-page__main__item__content__item__text"
                    >
                      {{ supplier.language || $t('common.no_data') }}
                    </span>
                  </div>
                </div>

                <div class="input-block input-block_white mt-1">
                  <!-- eslint-disable max-len -->
                  <div
                    class="custom-control custom-checkbox d-flex spso-custom-control spso-custom-control_white"
                  >
                    <input
                      id="supplier-isLocal"
                      v-model="supplier.isLocal"
                      type="checkbox"
                      class="custom-control-input"
                      :disabled="true"
                    >
                    <label
                      for="supplier-isLocal"
                      class="custom-control-label"
                    >
                      <span class="profile-page__main__item__content__item__title">
                        {{ $t('views.supplier_item.isLocal') }}
                      </span>
                    </label>
                  </div>
                  <!-- eslint-enable max-len -->
                </div>
                <div class="input-block input-block_white mt-1">
                  <!-- eslint-disable max-len -->
                  <div
                    class="custom-control custom-checkbox d-flex spso-custom-control spso-custom-control_white"
                  >
                    <input
                      id="supplier-isConsolidator"
                      v-model="supplier.isConsolidator"
                      :disabled="true"
                      type="checkbox"
                      class="custom-control-input"
                    >
                    <label
                      for="supplier-isConsolidator"
                      class="custom-control-label"
                    >
                      <span class="profile-page__main__item__content__item__title">
                        {{ $t('views.supplier_item.isConsolidator') }}
                      </span>
                    </label>
                  </div>
                  <!-- eslint-enable max-len -->
                </div>
              </v-col>
              <v-col
                cols="12"
                lg="4"
                class="profile-page__main__item__content"
              >
                <div class="profile-page__main__item__content__item">
                  <v-btn
                    v-if="!business && !read"
                    class="ml-auto"
                    color="primary"
                    :loading="sftpLoader"
                    outlined
                    large
                    @click="changeSFTP"
                  >
                    {{ $t('views.supplier_item.sftp_password_change') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-form>
    </v-card>
    <template v-if="supplier">
      <!-- contacts -->
      <div class="d-flex mb-3 align-items-end">
        <h1 class="h4 primary--text">
          {{ $t('common.contacts') }}
        </h1>
        <div class="ml-auto">
          <v-btn
            v-if="business && editor"
            class="mr-4"
            color="primary"
            outlined
            large
            @click="showContactsModal('add')"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            {{ $t('common.add') }}
          </v-btn>
        </div>
      </div>
      <v-card class="mb-5">
        <v-data-table
          :headers="headers"
          :items="contacts"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, 100],
          }"
          class="px-5"
        >
          <template
            v-slot:item.role="{ item }"
          >
            {{ $t(`enums.supplier_notification_roles.${item.role}`) }}
          </template>
          <template
            v-if="full || editor"
            v-slot:item.actions="{ item }"
          >
            <v-hover v-slot:default="{hover}">
              <v-icon
                class="mr-2"
                :class="hover ? '' : 'text--disabled'"
                color="primary"
                size="20"
                @click="showContactsModal('edit', item)"
              >
                mdi-pencil
              </v-icon>
            </v-hover>
            <v-hover
              v-if="item.id"
              v-slot:default="{hover}"
            >
              <v-icon
                :class="hover ? '' : 'text--disabled'"
                color="primary"
                size="20"
                @click="removeContact(item.id)"
              >
                mdi-trash-can-outline
              </v-icon>
            </v-hover>
          </template>
        </v-data-table>
      </v-card>
      <!-- part groups -->
      <div class="d-flex mb-3 align-items-end">
        <h1 class="h4 primary--text">
          {{ $t('common.part_groups') }}
        </h1>
        <div class="ml-auto">
          <v-btn
            v-if="business && editor"
            class="mr-4"
            color="primary"
            outlined
            large
            @click="showPartGroupModal()"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            {{ $t('common.add') }}
          </v-btn>
        </div>
      </div>
      <v-card class="mb-5">
        <v-data-table
          :headers="partGroupsHeaders"
          :items="supplier.partGroups || []"
          :items-per-page="-1"
          :footer-props="{
            itemsPerPageOptions: [-1],
          }"
          class="px-5"
        >
          <template
            v-if="full || editor"
            v-slot:item.actions="{ item }"
          >
            <v-hover
              v-slot:default="{hover}"
            >
              <v-icon
                :class="hover ? '' : 'text--disabled'"
                color="primary"
                size="20"
                @click="removePartGroup(item.guid)"
              >
                mdi-trash-can-outline
              </v-icon>
            </v-hover>
          </template>
        </v-data-table>
      </v-card>
      <!-- plants -->
      <div class="d-flex mb-3 align-items-end">
        <h1 class="h4 primary--text">
          {{ $t('common.plants') }}
        </h1>
      </div>
      <v-card class="mb-5">
        <v-data-table
          :headers="plantHeaders"
          :items="supplier.plants"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, 100],
          }"
          class="px-5"
        />
      </v-card>
      <contacts-modal
        v-model="contactsModal"
        :contact-selected="contactSelected"
        :type="modalType"
        :supplier="supplier.asdb"
        @submit="contactsModalSubmit"
      />
      <part-group-modal
        v-model="partGroupModal"
        :supplier="supplier.asdb"
        @submit="partGroupModalSubmit"
      />
      <sftp-modal
        v-model="sftpModal"
        :sftp="sftp"
      />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { contactRoles } from '@/utils/enums';
import ContactsModal from '@/components/profile/ContactsModal.vue';
import PartGroupModal from '@/components/profile/PartGroupModal.vue';
import SftpModal from '@/components/profile/SftpModal.vue';

export default {
  name: 'Supplier',

  components: {
    ContactsModal,
    PartGroupModal,
    SftpModal,
  },

  props: {
    asdb: {
      type: [String, Object],
      default: null,
    },
  },

  data: () => ({
    supplier: null,
    contacts: [],
    contactsModal: false,
    contactSelected: null,
    partGroupModal: false,
    modalType: 'add',
    sftp: null,
    sftpModal: false,
    sftpLoader: false,
    locales: [
      'en',
      'ru',
    ],
  }),

  computed: {
    ...mapState(['user']),
    ...mapGetters(['full', 'business', 'editor', 'read']),

    timezones() {
      return this.$moment.tz.names();
    },

    headers() {
      const headers = [
        { text: this.$t('common.role'), value: 'role' },
        { text: this.$t('common.name'), value: 'name' },
        { text: this.$t('common.phone'), value: 'phone' },
        { text: 'E-mail', value: 'email' },
      ];

      if (this.full || this.editor) {
        headers.push({
          text: this.$t('common.actions'), value: 'actions', sortable: false, width: 150, align: 'center',
        });
      }

      return headers;
    },

    plantHeaders() {
      return [
        { text: this.$t('common.plant'), value: 'plant' },
        { text: this.$t('common.shipping_frequency'), value: 'shippingFrequency' },
        { text: this.$t('common.transit_time_days'), value: 'transitTime' },
        { text: this.$t('common.analyst'), value: 'analyst' },
        { text: this.$t('common.consolidator'), value: 'consolidator' },
      ];
    },

    partGroupsHeaders() {
      const headers = [
        { text: this.$t('common.part_group'), value: 'name' },
      ];

      if (this.full || this.editor) {
        headers.push({
          text: this.$t('common.actions'), value: 'actions', sortable: false, width: 150, align: 'center',
        });
      }

      return headers;
    },
  },

  created() {
    this.getSupplier();
  },

  methods: {
    addMissedRoles(rows) {
      const supplierContactRoles = [...new Set(rows.map((o) => o.role))];
      const missedRoles = contactRoles
        .filter((role) => !supplierContactRoles.includes(role))
        .map((role) => ({ role }));

      return [...rows, ...missedRoles];
    },
    updatePage(supplier) {
      this.supplier = supplier;
      this.supplier.physicalCountry = supplier.physicalCountry ? supplier.physicalCountry.code : '';
      this.contacts = this.addMissedRoles(supplier.contacts);
    },
    async getSupplier() {
      const asdb = this.asdb || this.user.asdb;
      const params = {
        asdb, populate: 'physicalCountry partGroups',
      };
      try {
        const url = `/suppliers/${asdb}`
        // const { data = {} } = await this.$http.get('/suppliers-get-by-asdb', { params });
        const { data = {} } = await this.$http.get(url, { params });
        this.updatePage(data);
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },
    async save() {
      const params = { asdb: this.asdb || this.user.asdb };
      const body = {
        shippingAddress: this.supplier.shippingAddress,
        physicalAddress: this.supplier.physicalAddress,
        legalAddress: this.supplier.legalAddress,
        timezone: this.supplier.timezone,
        language: this.supplier.language,
      };
      console.log('save', body)
      try {
        const url = `/suppliers/${params.asdb}`
        this.$http.patch(url, body);
        // this.$http.patch('/suppliers-update-by-asdb', body, { params });
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },
    showContactsModal(type, contact) {
      this.contactSelected = contact;
      this.modalType = type;
      this.contactsModal = true;
    },
    async removeContact(id) {
      const params = {
        asdb: this.asdb || this.user.asdb,
        contactId: id,
      };

      try {
        await this.$http.delete('/supplier.contacts/delete-by-id', { params });
        await this.getSupplier();
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },
    async contactsModalSubmit() {
      await this.getSupplier();
      this.contactsModal = false;
    },
    async removePartGroup(guid) {
      const params = {
        asdb: this.asdb || this.user.asdb,
        groupGuid: guid,
      };

      try {
        await this.$http.delete('/supplier.part-groups/delete-by-guid', { params });
        await this.getSupplier();
      } catch (err) {
        this.$http.mockApiError(err);
      }
    },
    showPartGroupModal() {
      this.partGroupModal = true;
    },
    async partGroupModalSubmit() {
      await this.getSupplier();
      this.partGroupModal = false;
    },
    async changeSFTP() {
      this.sftpLoader = true;
      const params = { asdb: this.asdb || this.user.asdb };

      try {
        const { data = {} } = await this.$http.post('supplier.sftp-password/generate', null, { params });
        this.sftp = data;
        this.sftpModal = true;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.sftpLoader = false;
      }
    },
  },
};
</script>

<style lang="scss">
.profile-page .input-block {
  max-width: 350px;
}

.multiselect {
  max-width: 350px;

   ul {
    padding-left: 0;
  }
}
</style>
